import React, { useEffect, useState } from 'react';
import { apiUrl } from '../services/api';
import StatCard from './StatCard';

/**
 * "Travel Wrapped" — a Spotify-Wrapped-style summary of all your travel,
 * computed by GET /api/stats/wrapped. Renders nothing until there's data.
 */
export default function WrappedStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(apiUrl('/api/stats/wrapped'))
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('stats'))))
      .then((d) => { if (!cancelled) setStats(d); })
      .catch(() => { /* leave hidden on error */ });
    return () => { cancelled = true; };
  }, []);

  if (!stats) return null;

  const anyData = stats.total_distance_km || stats.total_flights
    || stats.countries_count || stats.cities_count || stats.total_nights;
  if (!anyData) return null;

  const km = Math.round(stats.total_distance_km || 0).toLocaleString();
  const lf = stats.longest_flight;
  const mvc = stats.most_visited_country;

  const cards = [
    { emoji: '✈️', value: km, label: 'km flown', accent: '#2563eb' },
    { emoji: '🌍', value: stats.countries_count, label: 'countries', accent: '#16a34a' },
    { emoji: '🏙️', value: stats.cities_count, label: 'cities', accent: '#c49b63' },
    { emoji: '🛏️', value: stats.total_nights, label: 'nights away', accent: '#0d9488' },
    { emoji: '🧳', value: stats.total_flights, label: 'flights', accent: '#7c3aed' },
    { emoji: '🔁', value: stats.equator_laps, label: 'laps around the equator', accent: '#db2777' },
  ];
  if (lf && (lf.from_city || lf.to_city)) {
    cards.push({
      emoji: '⏱️',
      value: `${Math.round(lf.distance_km || 0).toLocaleString()} km`,
      label: `longest: ${lf.from_city || '?'} → ${lf.to_city || '?'}`,
      accent: '#dc2626',
    });
  }
  if (mvc && mvc.country) {
    cards.push({ emoji: '📍', value: mvc.country, label: `most-visited (${mvc.count}×)`, accent: '#ea580c' });
  }

  return (
    <section className="tp-section">
      <div className="tp-card">
        <h2 className="tp-section__title">Travel Wrapped</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 12 }}>
          {cards.map((c, i) => <StatCard key={i} {...c} />)}
        </div>
      </div>
    </section>
  );
}
